<template>
    <div id="page">
        <div class="banners">
            <img src="~@/assets/images/resources/banner@2x.png" style="height: 300px;position: absolute;left:50%;margin-left: -960px;"  />
        </div>
        <div class="container" style="width: 1200px;">
            <div style="margin-bottom: 80px;margin-top: 50px;"><img  src="~@/assets/images/resources/图0@2x.png" style="height:497px;width: 1200px;"></div>
            <div class="title-font-1" style="margin: 20px 0 30px 0;">可视化需求对接工具</div>
            <div><img  src="~@/assets/images/resources/图1@2x.png" style="height: 379px;width: 1200px;"></div>
            <div class="title-font-1" style="margin: 20px 0 30px 0;">为供需双方提供信息平台对接平台</div>
            <div class="title-font-2">一键触达、实时、高效的技术对接解决方案</div>
            <div class="row">
                <div class="col-md-3">
                    <div class="f-30" style="color:rgba(4, 94, 255, 1);text-align: center;">有需求 极速发布</div>
                    <div class="f-20 part-2-text">一键提交企业需求，省时</div>
                    <div class="f-20 part-2-text">专人完善需求资料,省力</div>
                    <div class="f-20 part-2-text">微信实时查询进展，省心</div>
                </div>
                <div class="col-md-6">
                    <div style="text-align: center;"><img  src="~@/assets/images/resources/图2@2x.png" style="height: 294px;"></div>
                </div>
                <div class="col-md-3">
                    <div class="f-30" style="color:rgba(197, 118, 0, 1);text-align: center;">懂技术. 便捷接单</div>
                    <div class="f-20 part-2-text">人工验证需求信息，真实有效</div>
                    <div class="f-20 part-2-text">线上直联需求对象，无中介</div>
                    <div class="f-20 part-2-text">真实需求每日更新，实时有效</div>
                </div>
            </div>
            <div class="title-font-1" style="margin: 20px 0 30px 0;">智能匹配专家 迅速响应需求 实时反馈进度</div>
            <div class="row">
                <div class="col-md-6">
                    <img  src="~@/assets/images/resources/图3@2x.png" style="height: 500px;">
                </div>
                <div class="col-md-6" style="align-items: center;">
                    <div class="text f-26" style="margin: 120px 0 40px 0;">线上3秒极速匹配专家，线下3天科技伯乐及</div>
                    <div><p class="text f-20">十一步法需求发布模式引导企业准确描述技术需求</p>
                        <p class="text f-20">一键匹配专家，快速精准获取你想要的所有资源</p>
                        <p class="text f-20">低碳智库专家及时响应，主动跟进技术需求解决过程</p></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6" style="align-items: center;">
                    <div class="text f-26" style="margin: 120px 0 40px 0;">线上3秒极速匹配专家，线下3天科技伯乐及</div>
                    <div><p class="text f-20">十一步法需求发布模式引导企业准确描述技术需求</p>
                        <p class="text f-20">一键匹配专家，快速精准获取你想要的所有资源</p>
                        <p class="text f-20">低碳智库专家及时响应，主动跟进技术需求解决过程</p></div>
                </div>
                <div class="col-md-6">
                    <img  src="~@/assets/images/resources/图4@2x.png" style="height: 500px;">
                </div>
            </div>
            <div class="title-font-1" style="margin: 20px 0 30px 0;">为供需双方提供信息平台对接平台</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "resources",
        data() {
            return {}
        },
        components: {},
        watch: {},
        mounted() {

        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>
.banners{
    height: 300px;
    position: relative;
}
    .title-font-1{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 30px;
        color: #000000;
        line-height: 45px;
        text-align: center;
        font-style: normal;
    }
    .title-font-2{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        text-align: center;
        font-style: normal;
    }
    .f-20{
        font-size: 20px;
    }
    .f-26{
        font-size: 26px;
    }
    .f-30{
        font-size: 30px;
    }
    .part-2-text{
        border: 2px solid rgba(232, 239, 255, 1);
        border-radius: 35px;
        width: 300px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 15px auto;
    }
    .text{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
        text-align: left;
        font-style: normal;
    }
</style>
